"use client"

import { create } from "zustand"

export interface PendingAsk {
    id: string
    text: string
}

interface SideChatState {
    isOpen: boolean
    focusRequest: number
    recordSlot: HTMLElement | null
    recordClaims: number
    focusRecordChat: (() => void) | null
    askButtonWidth: number
    pendingAsk: PendingAsk | null
    setIsOpen: (isOpen: boolean) => void
    openAndFocus: (question?: string) => void
    clearPendingAsk: (id: string) => void
    setRecordSlot: (el: HTMLElement | null) => void
    claimRecordSlot: (focusChat: () => void) => () => void
    setAskButtonWidth: (width: number) => void
}

export const useSideChatStore = create<SideChatState>()(set => ({
    isOpen: true,
    focusRequest: 0,
    recordSlot: null,
    recordClaims: 0,
    focusRecordChat: null,
    askButtonWidth: 0,
    pendingAsk: null,
    setIsOpen: isOpen => set({ isOpen }),
    openAndFocus: question =>
        set(state => ({
            focusRequest: state.focusRequest + 1,
            pendingAsk: question
                ? { id: `ask-${state.focusRequest + 1}`, text: question }
                : state.pendingAsk,
        })),
    clearPendingAsk: id =>
        set(state =>
            state.pendingAsk?.id === id ? { pendingAsk: null } : state
        ),
    setRecordSlot: recordSlot => set({ recordSlot }),
    setAskButtonWidth: askButtonWidth => set({ askButtonWidth }),
    claimRecordSlot: focusChat => {
        set(state => ({
            recordClaims: state.recordClaims + 1,
            focusRecordChat: focusChat,
        }))
        return () =>
            set(state => ({
                recordClaims: state.recordClaims - 1,
                focusRecordChat:
                    state.focusRecordChat === focusChat
                        ? null
                        : state.focusRecordChat,
            }))
    },
}))
